export const data = [
    {
      fname:'John',
      orderId:"KCVF112L",
      itemName:'adgf',
      status:'low',
      queryDetails:"I ordered for a jumpsuit for 790/-but recieved the wrong product. So I requested for return of my product, but refund has not been initiated.",
      date:'07/22',
      type:'refund',
      rating:'3.8',
      action:'Resolve'
    },
    {
      fname:'John',
      orderId:"KCVF112L",
      itemName:'adgf',
      status:'low',
      queryDetails:"I ordered for a jumpsuit for 790/-but recieved the wrong product. So I requested for return of my product, but refund has not been initiated.",
      date:'07/22',
      type:'refund',
      rating:'3.8',
      action:'Resolve'
    },
    {
      fname:'John',
      orderId:"KCVF112L",
      itemName:'adgf',
      status:'low',
      queryDetails:"I ordered for a jumpsuit for 790/-but recieved the wrong product. So I requested for return of my product, but refund has not been initiated.",
      date:'07/22',
      type:'refund',
      rating:'3.8',
      action:'Resolve'
    },
  ]